// ======================================================================
// File Name       : UserHistoryStudentDetailCourseList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Popover, OverlayTrigger, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../../components/TableHead';
import * as UserHistoryStudentAction from '../../../actions/UserHistoryStudentAction';
import { convertObjectToList } from '../../../utils/UserUtils';
import { getItemBoxName, parseDateForDetail } from '../../../utils/index';
import {
  CONTENT_TYPE_STR,
  CONTENT_TYPE,
  DRILL_RESULT_EXP,
  END_CONDITION_TYPE_FOR_ITEM,
  START_CONDITION,
  DRILL_KIND,
} from '../../../constants/ContentHistoryConstant';
import { isDrillEndCondition, getDrillPercentLearning } from '../../../utils/ContentUtils';
import BackButton from '../../../components/BackButton';
import ReduxFormPaging from '../../ReduxFormPaging';
import CustomLink from '../../button/CustomLink';
import * as ICON from '../../../constants/IconConstants';

class UserHistoryStudentDetailCourseList extends React.Component {
  render() {
    const {
      learningHistoryList,
      contentList,
      userSecernId,
      handleSortState,
      itemList,
      goBack,
      goToDetail,
      dataSort,
      recordNum,
      getStartEndData,
      handleMouseEnter,
      handleMouseLeave,
      hoverIndex,
    } = this.props;
    const contentTypeArray = ['ビデオ', 'ドリル', '問題', 'ドキュメント', null, 'リンク'];
    const thead = [
      { title: 'コンテンツ種別', sortBy: 4, width:150 },
      { title: 'コース表示名', sortBy: null },
      { title: '実績', sortBy: null, width: 70 },
      { title: '学習開始日時', sortBy: 6, width: 200 },
      { title: '学習完了日時', sortBy: 7, width: 200 },
      { title: '操作', sortBy: null, width: 130 },
    ];
    let dataTable = null;
    let popoverHoverFocus = null;
    if (learningHistoryList && learningHistoryList.length) {
      dataTable = learningHistoryList.map((learningHistoryItem, index) => {
        const {
          historyHash,
          contentType,
          drillHistoryInfo,
          learningStartTime,
          learningEndTime,
          itemSecernId,
          contentSecernId,
          courseSecernId,
          itemName,
          videoViewRate,
          actualVideoPlayTime,
        } = learningHistoryItem;
        let drillKind = null;
        let startCondition = null;
        let performance = 0;
        let isShowDetailButton = false;
        switch (contentType) {
          case CONTENT_TYPE.DRILL_TEST:
            performance = '-';
            if (drillHistoryInfo) {
              drillKind = drillHistoryInfo.drillKind;
              startCondition = drillHistoryInfo.startCondition;
              performance = getDrillPercentLearning(drillHistoryInfo);
              let { drillResultExp } = drillHistoryInfo;
              drillResultExp = parseInt(drillResultExp, 10);
              if (drillResultExp === 0 || drillResultExp === 1 || drillResultExp === 2) {
                isShowDetailButton = true;
              }
            }
            break;
          case CONTENT_TYPE.MOVIE:
            performance = 0;
            if (videoViewRate) {
              performance = videoViewRate;
            }
            performance = `${performance}%`;
            break;
          case CONTENT_TYPE.DOCUMENT:
          case CONTENT_TYPE.LINK:
            performance = 0;
            if (learningEndTime) {
              performance = 100;
            }
            performance = `${performance}%`;
            break;
          default:
            performance = `${performance}%`;
            break;
        }

        let classNameDrillFailed = null;
        let buttonDetail = null;
        if (contentType === CONTENT_TYPE.DRILL_TEST) {
          popoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus">
              <Popover.Header>ドリル実施条件</Popover.Header>
              <Popover.Body>
                <span>
                  {'スタート条件：'}
                  {getItemBoxName(START_CONDITION, startCondition)}
                </span>
                <br />
                <span>
                  {'ドリル種別：'}
                  {getItemBoxName(DRILL_KIND, drillKind)}
                </span>
                <br />
                <span>
                  {'ドリル作成者：'}
                  {courseSecernId.startsWith('adhoc_') ? 'サービス利用ユーザー' : '管理画面利用ユーザー'}
                </span>
              </Popover.Body>
            </Popover>
          );
          buttonDetail = isShowDetailButton ? (
            <CustomLink
              className="margin-right-7 link-detail"
              onClick={() => {
                goToDetail(historyHash);
              }}
              text="詳細を見る"
            />
          ) : (
            <CustomLink
              className="margin-right-7 link-detail link-disabled"
              to="#"
              text="詳細を見る"
              onClick={(e) => e.preventDefault()}
            />
          );
          let isDrillEnd = true;
          if (itemList && itemList.byId[itemSecernId]) {
            const itemInfo = itemList.byId[itemSecernId];
            isDrillEnd = isDrillEndCondition(drillHistoryInfo, itemInfo);
          }
          if (!isDrillEnd) {
            classNameDrillFailed = 'backGround_drill_failed';
          }
        }
        // Step 10.3.0 START
        if (contentType === CONTENT_TYPE.MOVIE) {
          popoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus">
              <span>
                {'再生された時間：'}
                {parseInt(actualVideoPlayTime, 10) || 0}
                {' 秒'}
              </span>
            </Popover>
          );
        }
        // Step 10.3.0 END
        return (
          <OverlayTrigger
            trigger={contentType === CONTENT_TYPE.DRILL_TEST || contentType === CONTENT_TYPE.MOVIE ? ['hover', 'focus'] : []}
            placement="top"
            overlay={popoverHoverFocus}
            key={index}
          >
            <tr key={index} className={classNameDrillFailed} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
              <td>{contentTypeArray[contentType]}</td>
              <td>{itemName}</td>
              <td>{performance}</td>
              <td>{parseDateForDetail(learningStartTime)}</td>
              <td>{parseDateForDetail(learningEndTime)}</td>
              <td className="text-center">
                {(
                  buttonDetail
                )}
              </td>
            </tr>
          </OverlayTrigger>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="learningHistorySortType"
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{dataTable}</tbody>
        </Table>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default UserHistoryStudentDetailCourseList;
